var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolltotop"},[_c('a',{staticClass:"button-circle button-circle-sm button-circle-dark",attrs:{"href":"#"}},[_c('font-awesome-icon',{attrs:{"icon":['fa', 'arrow-up']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }